// src/components/OwnerSteps.jsx
import React from 'react';

export default function OwnerSteps({ language = 'en', onBack }) {
  const content = {
    en: [
      { title: "Create your free account", desc: "Sign up on the platform to access your dashboard.", imgDesc: "Illustration of account creation process" },
      { title: "Register your QR product", desc: "Link your bottle, tag or accessory to your account.", imgDesc: "Illustration of QR product being registered" },
      { title: "Personalize your return form", desc: "Set up how people can contact you and return your item.", imgDesc: "Illustration of return form customization" },
      { title: "Get notified if scanned", desc: "Receive alerts via email, SMS or push notification.", imgDesc: "Illustration of receiving notifications" },
      { title: "Recover your lost item", desc: "Coordinate pickup or delivery with the finder.", imgDesc: "Illustration of recovering a lost item" },
    ],
    es: [
      { title: "Crea tu cuenta gratuita", desc: "Regístrate en la plataforma y accede a tu panel.", imgDesc: "Ilustración del proceso de creación de cuenta" },
      { title: "Registra tu producto con QR", desc: "Asocia tu botella, etiqueta o accesorio a tu cuenta.", imgDesc: "Ilustración del registro de un producto con QR" },
      { title: "Personaliza tu formulario de devolución", desc: "Elige cómo deseas ser contactado para recuperar tu objeto.", imgDesc: "Ilustración de personalización del formulario" },
      { title: "Recibe notificaciones si se escanea", desc: "Recibe alertas por correo, SMS o notificación push.", imgDesc: "Ilustración de recepción de notificaciones" },
      { title: "Recupera tu artículo perdido", desc: "Coordina la entrega o recogida con quien lo encontró.", imgDesc: "Ilustración de recuperación de objeto perdido" },
    ],
    pt: [
      { title: "Crie sua conta gratuita", desc: "Cadastre-se na plataforma e acesse seu painel.", imgDesc: "Ilustração do processo de criação de conta" },
      { title: "Registre seu produto com QR", desc: "Associe sua garrafa, etiqueta ou acessório à sua conta.", imgDesc: "Ilustração do registro de produto com QR" },
      { title: "Personalize seu formulário de devolução", desc: "Escolha como deseja ser contatado para recuperar seu item.", imgDesc: "Ilustração da personalização do formulário de devolução" },
      { title: "Receba notificações ao escanear", desc: "Receba alertas por e-mail, SMS ou push.", imgDesc: "Ilustração de recebimento de notificações" },
      { title: "Recupere seu item perdido", desc: "Combine a devolução com quem encontrou o objeto.", imgDesc: "Ilustração da recuperação do item perdido" },
    ],
  };

  const stepsTitle = {
    en: "Step ",
    es: "Paso ",
    pt: "Passo ",
  };

  const stepImg = [
    "/assets/images/howitworks/ownerstep1.webp",
    "/assets/images/howitworks/ownerstep2.webp",
    "/assets/images/howitworks/ownerstep3.webp",
    "/assets/images/howitworks/ownerstep4.webp",
    "/assets/images/howitworks/ownerstep5.webp",
  ];

  const steps = content[language];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-[1536px] mx-auto px-4">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3 text-gray-800">
          {steps.map((step, index) => (
            <div key={index} className="p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition">
              <div className="text-xl font-bold text-[#48887B] mb-2">
                {`${stepsTitle[language]}${index + 1}`}
              </div>
              <img
                src={stepImg[index]}
                alt={step.imgDesc}
                className="w-20 h-20 mx-auto my-4 object-contain"
              />
              <h3 className="text-lg font-semibold text-center">{step.title}</h3>
              <p className="mt-2 text-gray-600 text-sm text-center">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <button
        onClick={onBack}
        className="mt-10 mx-auto block px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition"
      >
        {language === 'es'
          ? 'Volver'
          : language === 'pt'
          ? 'Voltar'
          : 'Back'}
      </button>
    </section>
  );
}
